import { useSelector } from 'react-redux';
import { processConfigurableNode } from '../../Common/NodeProcessor/NodeProcessor';
import { getDecisionNodeAtPath } from 'extractFromState';
import DTConfigurableNodeView from '../../DTConfigurableNodeView';

const DTConfigurableNode = () => {
  const decisionNode = useSelector(getDecisionNodeAtPath);

  return <DTConfigurableNodeView nodeConfig={decisionNode.configurableNode} processHandler={processConfigurableNode} />;
};

export default DTConfigurableNode;
